import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs';
import { ComponentInteractionService } from './common/component-interaction.service';
import { environment } from '../environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { toSignal } from '@angular/core/rxjs-interop'; // ObservableをSignalに変換
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  token: string | null = 'dumy';
  // isAuthenticated: boolean = false;
  isError = false;
  localWindow: Window = window;
  isShowManualOrAssist = false;
  isShowSideMenuToggleButton = false;
  currentURL: string | null = null;
  envName = environment.ENV_NAME;

  router: Router = inject(Router);
  interactionService: ComponentInteractionService = inject(ComponentInteractionService);

  private auth = inject(AuthService);
  isAuthenticated = toSignal(this.auth.isAuthenticated$, { initialValue: false });
  // isLoading = toSignal(this.auth.isLoading$, { initialValue: true });

  ngOnInit() {
    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e: any) => {
      this.currentURL = e.url;
    });

    // 500エラーページでリロードした際はAPIコールさせない
    if (this.currentURL === '/500') {
      this.isError = true;
      return;
    }
  }

  logout = () => {
    // this.authService.logout();
  };
}
